import React, {useEffect, useRef, useState} from 'react'
import {useGlobalContext} from '../../../contexts/global_context'
import {BACKEND_URL, BRAND_NAME} from '../../../data/config'
import AdminContainer from '../../../components/admin/AdminContainer'
import {Grid} from '@mui/material'
import {ValidatorForm, TextValidator} from 'react-material-ui-form-validator'
import {getFieldErrorParams, getInputValue} from '../../../utils'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import {Helmet} from 'react-helmet'

const TopNotificationAdminPage = () => {
  const {sendAjax} = useGlobalContext()
  const form = useRef()
  const [fieldErrors, setFieldErrors] = useState({})
  const [formValues, setFormValues] = useState({
    enabled: false,
    notification_type: 10,
    message_html: '',
  })

  useEffect(() => {
    sendAjax({
      url: `${BACKEND_URL}/api/v1/notifications/admin/top-notification/`,
      method: 'get',
      data: {},
    }).then(r => {
      if (r.data.status_code === 200) {
        setFormValues(r.data.data)
      }
    })
  }, [])

  const handleChange = (event) => {
    setFormValues({...formValues, [event.target.name]: getInputValue(event.target)})
    setFieldErrors({})
  }

  const handleSubmit = () => {
    sendAjax({
      url: `${BACKEND_URL}/api/v1/notifications/admin/top-notification/`,
      method: 'post',
      data: formValues,
    }).then(r => {
      if (r.data.status_code === 400) {
        setFieldErrors(r.data.data)
      }
    })
  }

  return (
    <AdminContainer>
      <Helmet>
        <title>Top Notification - {BRAND_NAME}</title>
      </Helmet>

      <Box component={ValidatorForm} ref={form} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={4}>
            <TextValidator
              select
              label="Type"
              name={'notification_type'}
              variant={'outlined'}
              fullWidth={true}
              onChange={handleChange}
              value={formValues.notification_type}
              {...getFieldErrorParams(fieldErrors, 'notification_type')}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value={10}>Success</MenuItem>
              <MenuItem value={20}>Danger</MenuItem>
              <MenuItem value={30}>Warning</MenuItem>
              <MenuItem value={40}>Primary</MenuItem>
            </TextValidator>
          </Grid>

          <Grid item xs={12} sm={12} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  name="enabled"
                  checked={!!formValues.enabled}
                  onChange={(e) => setFormValues({...formValues, enabled: e.target.checked})}
                />
              }
              label="Enabled"
            />
          </Grid>

          <Grid item xs={12}>
            <TextValidator
              label={'Message HTML'}
              placeholder={'<b>All services working great.</b> {{CURRENT_DATE}}'}
              name={'message_html'}
              variant={'outlined'}
              fullWidth={true}
              multiline
              minRows={4}
              onChange={handleChange}
              value={formValues.message_html}
              {...getFieldErrorParams(fieldErrors, 'message_html')}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>

        <Button
          color={'primary'}
          type={'submit'}
          variant="contained"
          sx={{
            margin: '20px 0 20px 0',
          }}
        >
          Save
        </Button>
      </Box>
    </AdminContainer>
  )
}

export default TopNotificationAdminPage
